<template>
  <div>
    <div v-if="isWin">
      <!-- winTitle -->
      <div class="headerClass">{{ detailTitle }}</div>
      <BaseDetail
        :baseMsg="baseMsg"
        :detailObj="detailObj"
        :deviceType="newDeviceType"
        :deviceProperty="deviceProperty"
        :detailLoading="detailLoading"
        :detailRuleObj="detailRuleObj"
        :detailNetObj="detailNetObj"
        v-bind="$attrs"
        class="comp-sensor-detail uk-padding-small"
      >
      </BaseDetail>
    </div>

    <BaseDetailDialog
      v-else
      :isShowDetail.sync="detailIsShow"
      :title="detailTitle"
      :baseMsg="baseMsg"
      :detailObj="detailObj"
      :deviceType="newDeviceType"
      :deviceProperty="deviceProperty"
      :detailLoading="detailLoading"
      :detailRuleObj="detailRuleObj"
      :detailNetObj="detailNetObj"
      v-bind="$attrs"
      class="comp-sensor-detail"
      :getList="getList"
    ></BaseDetailDialog>
  </div>
</template>

<script>
import BaseDetailDialog from './component/baseDetailDialog.vue'
import { getBaseInfo } from '@/api/modules/base.js'
import bus from '@/utils/bus'
import { isWin } from '@/utils/winDetail'
import BaseDetail from './component/baseDetail.vue'

export default {
  props: {
    id: {},
    name: {},
    show: {}
  },
  components: {
    BaseDetailDialog,
    BaseDetail
  },
  computed: {
    isWin () {
      return isWin()
    }
  },
  data () {
    return {
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url',
          content: ''
        },
        {
          text: $t('integration.mount_'),
          key: 'carrierName',
          content: ''
        },
        {
          text: $t('智能底座编号'),
          key: 'plinth_code',
          content: ''
        },
        {
          text: $t('智能底座类型'),
          key: 'type',
          content: ''
        },

        // {
        //     text: $t('绑定设备'),
        //     key: 'sensor',
        //     content: ''
        // },
        {
          text: 'public.table_create_time',
          key: 'create_time',
          content: ''
        },
        {
          key: 'nickname',
          text: 'device.nickname',
          content: ''
        },
        {
          key: 'description',
          text: $t('public.table_desc'),
          content: ''
        }
      ],
      detailRuleObj: [
        {
          key: 'collectInterval',
          text: $t('integration.acquisition_interval'),
          isBool: true
        },
        {
          key: 'exCollectInterval',
          text: $t('integration.abnormal_collection_interval'),
          isBool: true
        },
        {
          key: 'tempCollectInterval',
          text: $t('integration.temperature_acquisition_interval'),
          isBool: true
        },
        {
          key: 'tempChange',
          text: $t('integration.temperature_change_threshold'),
          isBool: true
        },
        {
          key: 'tempMaxReport',
          text: $t('integration.maximum_temperature_reporting_interval'),
          isBool: true
        },
        {
          key: 'tempMinReport',
          text: $t('integration.minimum_temperature_reporting_interval'),
          isBool: true
        },

        {
          key: 'humCollectInterval',
          text: $t('integration.humidity_collection_interval'),
          isBool: true
        },
        {
          key: 'humChange',
          text: $t('integration.humidity_change_threshold'),
          isBool: true
        },
        {
          key: 'humMaxReport',
          text: $t('integration.maximum_humidity_reporting_interval'),
          isBool: true
        },
        {
          key: 'humMinReport',
          text: $t('integration.humidity_minimum_reporting_interval'),
          isBool: true
        }
      ],
      detailNetObj: [
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'transmitPower',
          text: 'device.transmit_power',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          key: 'inNetInterval',
          text: 'device.in_net_interval',
          isBool: true
        },
        {
          key: 'devEui',
          text: 'DevEUI',
          isBool: true
        },
        {
          key: 'appEui',
          text: 'AppEUI',
          isBool: true
        },
        {
          key: 'appKey',
          text: 'AppKey',
          isBool: true
        }
      ],
      detailObj: null,
      newDeviceType: {},
      deviceProperty: {},
      detailLoading: false,
      detailIsShow: false,
      detailTitle: '',
      getList: () => null
    }
  },
  watch: {
    detailIsShow (newval) {
      this.$emit('update:show', newval)
    }
  },
  methods: {
    detailFn (id, name) {
      // console.log('row===>', row);
      this.detailTitle = `[${name}]` + this.$t('public.details')

      this.detailIsShow = true
      this.detailLoading = true
      getBaseInfo(id)
        .then(({ result, state }) => {
          result.plinth.pictureBase64 =
            result.plinth.pictureBase64 || result.deviceType.pictureBase64
          this.detailObj = result.plinth
          this.newDeviceType = result.deviceType
          this.deviceProperty = result.deviceProperty || {}
          const { plinth, appConfig, netConfig } = result
          // 基本的数据
          plinth.create_time = this.$timetransition(plinth.create_time)
          // this.baseMsg.find(item => item.key === 'sensor').content = '';

          this.baseMsg.forEach(item => {
            for (const newKey in plinth) {
              item.key === newKey ? (item.content = plinth[newKey]) : null
              if (item.key === 'url') {
                item.content = `${plinth.fullPath || plinth.scopeName}`
              }
            }
          })

          const carrierIndex = this.baseMsg.findIndex(
            item => item.key === 'carrierName'
          )

          if (!this.baseMsg[carrierIndex].content) {
            this.baseMsg.splice(carrierIndex, 1)
          }

          this.getGenerValueFn(this.detailRuleObj, appConfig)
          this.getGenerValueFn(this.detailNetObj, netConfig)
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        item.content = ''
        for (const newKey in obj) {
          item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    }
  },
  mounted () {
    // 是否插入到body中
    if (this.appendToBody) {
      this.$nextTick(() => {
        const body = document.querySelector('body')
        if (body.append) {
          body.append(this.$el)
        } else {
          body.appendChild(this.$el)
        }

        document.body.removeChild(this.$el)
        this.$destroy()
      })
    }

    bus.$on('baseParam', (id, name, getList) => {
      this.detailFn(id, name)
      this.detailIsShow = true

      if (getList) {
        this.getList = getList
      }
    })

    // win
    // if (this.$route.query && this.$route.query.id) {
    //     const { id, name } = this.$route.query;
    //     this.detailFn(id, name);
    // }
  },
  beforeDestroy () {
    bus.$off('baseParam')
  }
}
</script>

<style scoped lang="scss">
.headerClass {
  height: 60px;
  line-height: 60px;
  padding-bottom: 10px;
  box-sizing: border-box;
  border-bottom: 1px solid #ccc;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}
</style>
